import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Category {
  id: string
  name: string
}

export interface UseCategoriesResult {
  categories: Category[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useCategories(fetchOnMount = false): UseCategoriesResult {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ categories: Category[] }>('/admin/conversation-management/categories/dropdown')
      setCategories(res.categories || [])
    } catch (e) {
      console.error('Failed to fetch categories:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch categories')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { categories, loading, error, refetch }
}
